export default __webpack_public_path__ + "static/media/fortune-life.6805c8d6.png";